import Paper from "@material-ui/core/Paper"
import { makeStyles } from "@material-ui/core/styles"
import TableContainer from "@material-ui/core/TableContainer"
import { AdvancedTable, TableSupport } from "dsilo-ui-components"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { getTasks } from "../../store/actions"
import { Loader } from "../loader";
import { PUBLIC_PATH } from "../../constants";
import { fetchPrivilegeSupport } from '../../utility/AbilityCheck'; // Import ability function

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%"
    },
    paper: {
        width: "100%",
        marginBottom: theme.spacing(2)
    },
    headerClass: {
        backgroundColor: "#cecece"
    },
    confirmationDialoge: {
        "& .MuiDialog-paperWidthSm": {
            height: "250px",
            width: "600px"
        }
    },
    para: {
        fontSize: "28px !important",
        fontWeight: 600,
        color: "#000"
    }
}))

const MyTaskListWrapper = (props) => {
    const sharedJSON = {
        order: "asc",
        orderBy: null,
        selected: [],
        tableData: [],
        filterTableData: [],
        page: 0,
        count: 10,
        rowsPerPage: props.data.chartData?.pagination?.rowsPerPage
            ? props.data.chartData?.pagination?.rowsPerPage
            : 10,
        searchText: "",
        filterList: [],
        filterData: []
    }

    console.log('MyTaskListWrapper', )

    const classes = useStyles()

    const [state, setState] = useState({
        ...sharedJSON
    })
    const [conditions, setConditions] = useState([])
    const [filterConditions, setFilterConditions] = useState([])
    const [fetched, setFetched] = useState(false)
    const [parentInvoked, setParentInvoked] = useState(false)
    const [parentData, setParentData] = useState([])
    const [showTable, setShowTable] = useState(false)
    const [deleteConfirmState, setDeleteConfirm] = useState({
        isOpen: false,
        deleteMessage: "Are you sure you want to delete ?",
        data: null
    })
    const { tasks } = props.formData
    const { data } = props
    const { chartData } = props.data
    const [previlageData, setPrevilageData] = useState("")

    // Generate abilities based on privileges
    const [ability, setAbility] = useState(null);

    // const ability = defineAbilities(privileges, selectedDataModelID);


    const {
        fetchType,
        selectedDataModel,
        selectedDataElement,
        externalFilter,
        download,
        selectedInnerDataElement,
        isFiltersInterConnected
    } = props.data.chartData
    const { externalFilterData } = props.formData
    const _conditions = props.data.chartData?.conditions
    const [hasParentDocument, setHasParentDocument] = useState(false)
    const conditionType = [
        "${DOCUMENT}",
        "${CURRENT_DOCUMENT}",
        "${CURRENT_USER}",
        "${SYSTEM_USER}"
    ]
    let parentController = 0

    useEffect(() => {
        let payload = {
            appId: props.match.params.appid,
            dataUniqueId: props.data.chartUniqueId + '_data'
        };
        props.getTasks(payload);
    }, []);

    useEffect(() => {
        if ( tasks &&  tasks[props.data.chartUniqueId + "_data"]) {
            const keysArr = ["_id"]
            setState({
                ...TableSupport.setDatafromApi2(
                    getData(tasks[props.data.chartUniqueId + "_data"]),
                    keysArr,
                    state,
                    getColumns()
                ),
                count: tasks[props.data.chartUniqueId + "_data"]?.length
            })
        }
    }, [props.formData.tasks[props.data.chartUniqueId + "_data"]])

    const getColumns = () => {
        let COLUMNS = []
        if (data && data?.chartData) {
                if (data.chartData?.selectedDataElement?.length) {
                    COLUMNS = data.chartData.selectedDataElement.map((i) => {
                        return {
                            id: i.value,
                            name: i.value,
                            numeric: false,
                            disablePadding: false,
                            label: i.label,
                            sort: true
                        }
                    })
                }
        }
        return COLUMNS
    }

    const getData = (dataSource) => {
        const clonedDataSource = JSON.parse(JSON.stringify(dataSource))
        return clonedDataSource.map((item) => {
            const keys = Object.keys(item)
            keys.forEach((key) => {
                if (key && typeof item[key] !== "string") {
                    item[key] = item[key] ? JSON.stringify(item[key]) : ""
                }
            })
            return item
        })
    }

    const handleChangePage = (event, page) => {
        setState({ ...state, page: page })
    }

    const handleChangeRowsPerPage = (event) => {
        setState({ ...state, rowsPerPage: event.target.value, page: 0 })
    }

    const onRowClick = (rowData, rowMeta) => {
        console.log("onRowClick")
    }

    const searchHandler = (e) => {
        setState({ ...state, searchText: e ? e.target.value : "" })
    }

    const handleInputChange = (event) => {
        console.log(
            "value:" + event.target.value + " checked: " + event.target.checked
        )
        const obj = state.filterTableData
        const list = obj.columns
        list.map((item, index) => {
            if (item.name === event.target.value)
                list[index].checked = event.target.checked
        })
        obj.columns = [...list]
        setState({ ...state, filterTableData: obj })
        setState({ ...TableSupport.updateTableData(state) })
    }

    const resetFilters = (event) => {
        setState({ ...state, filterList: [] })
    }

    const handleDropdownChange = (event, index, column) => {
        const value = event.target.value === "All" ? [] : [event.target.value]
        // filterUpdate(index, value, column, 'dropdown');
        const list = state.filterList
        list[index] = event.target.value
        setState({ ...state, filterList: [...list] })
        setState({ ...TableSupport.updateTableData(state) })
    }

    const handleRequestSort = (event, property) => {
        const obj = TableSupport.requestSort(event, property, state)
        console.log("obj", obj)
        setState({ ...state, ...obj })
    }

    const handleSelectAllClick = (event) => {
        setState({
            ...state,
            selected: TableSupport.handleTableSelectAllClick(
                event,
                state.filterTableData.datasets
            )
        })
    }

    const tableCrudOperations = (item, type) => {
        console.log(item)
        if (type === "edit") {
            props.history.push({
                pathname: `/${PUBLIC_PATH}${props.match.params.appid}/page/${chartData.editPage}/${item._id}`
            })
        }
        if (type === "view") {
            props.history.push({
                pathname: `/${PUBLIC_PATH}${props.match.params.appid}/page/${chartData.viewPage}/${item._id}`
            })
        }
        if (type === "delete") {
            setDeleteConfirm({
                ...deleteConfirmState,
                isOpen: true,
                data: item._id
            })
        }
        if (type === "download") {
        }
        if (type === "link") {
            props.history.push({
                pathname: `/${PUBLIC_PATH}${props.match.params.appid}/page/${chartData.link}/${item._id}`
            })
        }
    }

    const handleCheck = (event, id) => {
        const { selected } = state
        const newSelected = TableSupport.handleSelectedRow(event, id, selected)
        setState({ ...state, selected: newSelected })
    }

    const onApiDownloadClick = (config, index) => {
        console.log("download api data", config, index)

        const {
            download,
            selectedDataElement,
            fetchType,
            selectedInnerDataElement
        } = props.data.chartData
        if (download) {
            const payload = {
                dataModelId: selectedDataModel,
                appid: props.match.params.appid,
                fields: selectedDataElement.map((i) => i.value).join(","),
                downloadType: "excel"
            }
            if (fetchType) {
                payload.fetchType = fetchType
            }
            console.log({ selectedInnerDataElement })
            if (selectedInnerDataElement?.length) {
                payload.viewFields = selectedInnerDataElement
                    .map((i) => i.value)
                    .join(",")
            }
            payload.conditions = [...conditions, ...filterConditions]

            props.downloadSheet(payload)
        }
    }

    // Member Privileges code end here
    useEffect(() => {
        const { privilegeData, ability } = fetchPrivilegeSupport(props, chartData);
        setPrevilageData(privilegeData);
        setAbility(ability);
    }, [
        props.formData.document[`${props.match.params.appid}_memberprivileges`],
        props?.privilegesSupport,
        props.match.params.page,
        window.location.pathname,
        chartData?.selectedDataModel
    ]);
    // Member Privileges code end here

    return (
        <div className={classes.root}>
            <Paper className={classes.paper} elevation={0}>
                {state.tableData && (
                    <TableContainer
                        style={{ maxWidth: "92vw" }}
                        component={Paper}
                    >
                        {state.tableData && (
                            <AdvancedTable
                                title={chartData.title}
                                key={props.data.chartUniqueId}
                                name='ContractList'
                                onRowClick={onRowClick}
                                {...props}
                                {...state}
                                chartData={chartData}
                                searchHandler={searchHandler}
                                isExport={download}
                                isViewCoulmns
                                isSearch
                                isFilter
                                hasCheckbox={false}
                                actions={{
                                    edit: chartData.editPage,
                                    view: chartData.viewPage,
                                    delete: chartData.delete,
                                    copy: false,
                                    download: true,
                                    link: chartData.link
                                }}
                                isTablePagination
                                isTableHead
                                isTableSubHeader={false}
                                exportArray={
                                    download === "local"
                                        ? [
                                            {
                                                key: "xls",
                                                name: "Excel",
                                                isVisible: true
                                            },
                                            {
                                                key: "csv",
                                                name: "csv",
                                                isVisible: true
                                            }
                                        ]
                                        : [
                                            {
                                                key: "xlsx",
                                                name: "Excel",
                                                isVisible: true
                                            }
                                        ]
                                }
                                handleInputChange={handleInputChange}
                                handleExoprtItemClick={onApiDownloadClick}
                                resetFilters={resetFilters}
                                pagination={props.data.chartData?.pagination}
                                handleDropdownChange={handleDropdownChange}
                                handleRequestSort={handleRequestSort}
                                handleSelectAllClick={handleSelectAllClick}
                                tableCrudOperations={tableCrudOperations}
                                handleCheck={handleCheck}
                                handleChangePage={handleChangePage}
                                handleChangeRowsPerPage={
                                    handleChangeRowsPerPage
                                }
                                onExternalFilterChange={() => { }}
                                externalFilterData={
                                    externalFilterData
                                        ? fetchType
                                            ? [
                                                ...(externalFilterData[
                                                    props.data
                                                        .chartUniqueId +
                                                    "_externalFilter_viewFields"
                                                ]?.data || []),
                                                ...(externalFilterData[
                                                    props.data
                                                        .chartUniqueId +
                                                    "_externalFilter_fields"
                                                ]?.data || [])
                                            ]
                                            : externalFilterData[
                                                props.data.chartUniqueId +
                                                "_externalFilter"
                                            ]?.data
                                        : []
                                }
                                externalFilters={externalFilter}
                                externalFilterValues={filterConditions}
                                stripRows // for changing BGcolor of odd rows
                                headerstyle={{
                                    fontSize: "14px",
                                    color: "rgba(0, 0, 0, 0.87)",
                                    textAlign: "left",
                                    backgroundColor: "#"
                                }}
                                subHeaderstyle={{
                                    fontSize: "14px",
                                    color: "rgba(0, 0, 0, 0.87)",
                                    backgroundColor: "#FFF",
                                    textAlign: "left"
                                }}
                                headerClass={classes.headerClass}
                                rowStyle={{
                                    fontSize: "14px",
                                    color: "rgba(0, 0, 0, 0.87)",
                                    backgroundColor: "none",
                                    lineHeight: 1.5,
                                    textAlign: "left"
                                }}
                                isLoading={props.formData[props.data.chartUniqueId + "_data_loading"]}
                                loader={<Loader />}
                                previlageData={previlageData}
                                ability={ability}
                            />
                        )}
                    </TableContainer>
                )}
            </Paper>
        </div>
    )
}

const mapDispatchToProps = {
    getTasks,
};

const mapStateToProps = state => {
    return {
        appConfig: state.appConfig.app,
        apps: state.app.app,
        login: state.login,
        user: state.user,
        formData: state.form,
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyTaskListWrapper));
